import {Container} from "@chakra-ui/react";
import {ReactNode} from "react";

export function ContentContainer({children}: { children: ReactNode }) {
    return (
        <Container maxW={'2xl'} padding={5}>
            {children}
        </Container>
    );
}